import { USER_ROLES } from '~/types'

// Roles whose access is scoped to the RFI section only. Both RFI ops roles receive identical
// treatment: they see only RFI management, the landing page redirects there, and every other
// tab/section is hidden. (Team management remains available: all roles can self-serve add team
// members.) Category-level scoping (account vs payment) is enforced server-side via the dashboard
// BFF, not here.
const RFI_OPERATION_ROLES: USER_ROLES[] = [
  USER_ROLES.ONBOARDING_OPERATIONS,
  USER_ROLES.TRANSACTIONS_RFI_OPERATIONS,
]

export const isRfiOperationRole = (role?: USER_ROLES | string | null): boolean =>
  RFI_OPERATION_ROLES.includes(role as USER_ROLES)
